/*----------------------------------
- GENERATED FILE
----------------------------------*/

// This file is generated by Proteum from client/pages/platform.tsx.
// Do not edit it manually.

import type __GeneratedRouteApp from "@/client/index";

/*----------------------------------
- DEPENDANCES
----------------------------------*/

import React from 'react';
import { ArrowRight, Award, Briefcase, Clock, FileText, Globe, Rocket, Search, Shield, TrendingUp, Users } from 'lucide-preact';

/*----------------------------------
- APP
----------------------------------*/

import Motion, { fadeIn } from '@/client/components/Motion';
import ClientLogosCarousel from '@/client/components/marketing/ClientLogosCarousel';
import PublicFooter from '@/client/components/marketing/PublicFooter';
import { SegmentedSwitch } from '@/client/components/ui/Switches';
import { useCountUp } from '@/client/hooks/useCountUp';
import Page from '@/client/pages/_layout/_page';
import { MARKETING_LOGO_URL, MARKETING_URLS } from '@/client/catalogs/marketing/navigation';

/*----------------------------------
- CONTROLEUR
----------------------------------*/

export const __register = (app: __GeneratedRouteApp) => {
  const { Router } = app;
  return Router.page('/platform', { ...({
  static: {
    refresh: '1h',
    urls: ['/platform']
  }
}), ...{ filepath: "/app/client/pages/platform.tsx", sourceLocation: { line: 25, column: 1 }, id: "platform" } }, null, ({}) => {
  const [mobileMenuOpen, setMobileMenuOpen] = React.useState(false);
  const recruitersCount = useCountUp({
    end: 10000,
    duration: 2500,
    suffix: '+'
  });
  const countriesCount = useCountUp({
    end: 50,
    duration: 2000,
    suffix: '+'
  });
  const daysCount = useCountUp({
    end: 12,
    duration: 1500,
    suffix: ' days'
  });
  return <Page withLayout={false}>
            <div className="min-h-screen bg-gradient-to-br from-orange-50 via-white to-pink-50">
                <header className="fixed top-0 left-0 right-0 bg-white/95 backdrop-blur-md border-b border-orange-100 z-50 shadow-sm">
                    <div className="max-w-7xl mx-auto px-6 lg:px-8 py-4">
                        <div className="flex items-center justify-between gap-4">
                            <a href={MARKETING_URLS.platform} className="flex items-center gap-3">
                                <img src={MARKETING_LOGO_URL} alt="CrossPath Logo" className="w-10 h-10" />
                                <span className="text-2xl font-bold bg-gradient-to-r from-orange-600 to-pink-600 bg-clip-text text-transparent">
                                    CrossPath Platform
                                </span>
                            </a>

                            <nav className="hidden md:flex items-center gap-8">
                                <a href="#how-it-works" className="text-slate-700 hover:text-orange-600 font-medium transition-colors">
                                    How it Works
                                </a>
                                <a href="#benefits" className="text-slate-700 hover:text-orange-600 font-medium transition-colors">
                                    Benefits
                                </a>
                                <a href="#stats" className="text-slate-700 hover:text-orange-600 font-medium transition-colors">
                                    Stats
                                </a>
                            </nav>

                            <div className="hidden md:flex items-center gap-3">
                                <SegmentedSwitch value={false} onChange={value => {
                if (value && typeof window !== 'undefined') {
                  window.location.href = MARKETING_URLS.home;
                }
              }} labels={{
                true: 'SaaS',
                false: 'Platform'
              }} />
                                <a href={MARKETING_URLS.login} className="text-slate-700 hover:text-orange-600 font-medium transition-colors px-4 py-2">
                                    Login
                                </a>
                                <a href={MARKETING_URLS.platformSignup} className="bg-gradient-to-r from-orange-500 to-pink-500 hover:from-orange-600 hover:to-pink-600 text-white px-6 py-2.5 rounded-xl font-semibold transition-all shadow-lg hover:shadow-xl transform hover:scale-105">
                                    Join as Recruiter
                                </a>
                            </div>

                            <button type="button" onClick={() => setMobileMenuOpen(prev => !prev)} className="md:hidden p-2" aria-label="Toggle platform menu">
                                {mobileMenuOpen ? 'X' : '≡'}
                            </button>
                        </div>

                        {mobileMenuOpen && <div className="md:hidden mt-4 pb-4 border-t border-orange-100 pt-4">
                                <nav className="flex flex-col gap-4">
                                    <a href="#how-it-works" className="text-slate-700 hover:text-orange-600 font-medium">
                                        How it Works
                                    </a>
                                    <a href="#benefits" className="text-slate-700 hover:text-orange-600 font-medium">
                                        Benefits
                                    </a>
                                    <a href="#stats" className="text-slate-700 hover:text-orange-600 font-medium">
                                        Stats
                                    </a>
                                    <div className="pt-2">
                                        <SegmentedSwitch value={false} onChange={value => {
                  if (value && typeof window !== 'undefined') {
                    window.location.href = MARKETING_URLS.home;
                  }
                }} labels={{
                  true: 'SaaS',
                  false: 'Platform'
                }} />
                                    </div>
                                    <a href={MARKETING_URLS.platformSignup} className="bg-gradient-to-r from-orange-500 to-pink-500 text-white px-6 py-2.5 rounded-xl font-semibold shadow-lg text-center">
                                        Join as Recruiter
                                    </a>
                                </nav>
                            </div>}
                    </div>
                </header>

                <section className="pt-32 pb-20 px-6 lg:px-8 bg-gradient-to-br from-orange-50 via-white to-pink-50">
                    <div className="max-w-7xl mx-auto">
                        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
                            <Motion tag="div" initial="hidden" animate="visible" variants={fadeIn} transition={{
              duration: 0.6
            }}>
                                <h1 className="text-5xl lg:text-6xl font-bold bg-gradient-to-r from-orange-600 via-pink-600 to-purple-600 bg-clip-text text-transparent mb-6 leading-tight">
                                    Join 10,000+ Recruiters Working Worldwide
                                </h1>
                                <p className="text-xl text-slate-700 mb-8 leading-relaxed">
                                    Work on recruitment missions from top companies. Choose your projects, set your pace, and grow through successful placements.
                                </p>
                                <div className="flex flex-col sm:flex-row gap-4 items-start mb-8">
                                    <a href={MARKETING_URLS.platformSignup} className="bg-gradient-to-r from-orange-500 to-pink-500 hover:from-orange-600 hover:to-pink-600 text-white px-10 py-4 rounded-xl font-semibold transition-all shadow-lg hover:shadow-xl flex items-center justify-center gap-2 hover:scale-105 transform">
                                        Start Recruiting Now
                                        <ArrowRight size={20} />
                                    </a>
                                    <div className="flex flex-col gap-1">
                                        <div className="text-sm text-slate-500">Free to join</div>
                                        <div className="text-sm text-slate-500">No exclusivity required</div>
                                    </div>
                                </div>

                                <div className="grid grid-cols-3 gap-4">
                                    {[{
                  value: recruitersCount,
                  label: 'Active Recruiters',
                  borderClassName: 'border-orange-100',
                  textClassName: 'from-orange-600 to-pink-600',
                  delay: 0.3
                }, {
                  value: daysCount,
                  label: 'Avg. Close Time',
                  borderClassName: 'border-pink-100',
                  textClassName: 'from-pink-600 to-purple-600',
                  delay: 0.4
                }, {
                  value: 'Verified',
                  label: 'Closeout Flow',
                  borderClassName: 'border-purple-100',
                  textClassName: 'from-purple-600 to-orange-600',
                  delay: 0.5
                }].map((stat, index) => <Motion tag="div" key={index} className={`bg-white rounded-xl p-4 shadow-md border ${stat.borderClassName}`} initial={{
                  opacity: 0,
                  scale: 0.8
                }} animate={{
                  opacity: 1,
                  scale: 1
                }} transition={{
                  delay: stat.delay,
                  duration: 0.5
                }}>
                                            <div className={`text-2xl font-bold bg-gradient-to-r ${stat.textClassName} bg-clip-text text-transparent`}>
                                                {stat.value}
                                            </div>
                                            <div className="text-xs text-slate-600">{stat.label}</div>
                                        </Motion>)}
                                </div>
                            </Motion>

                            <Motion tag="div" initial={{
              opacity: 0,
              scale: 0.95
            }} animate={{
              opacity: 1,
              scale: 1
            }} transition={{
              duration: 0.6,
              delay: 0.2
            }} className="relative">
                                <div className="bg-white rounded-2xl shadow-2xl p-6 border border-orange-100">
                                    <div className="bg-gradient-to-br from-orange-100 via-pink-100 to-purple-100 rounded-xl p-8">
                                        <div className="space-y-4">
                                            {[{
                      title: 'Senior Software Engineer',
                      details: 'Tech Startup • Remote • Open mission',
                      borderClassName: 'border-orange-500',
                      gradientClassName: 'from-orange-500 to-pink-500'
                    }, {
                      title: 'Marketing Director',
                      details: 'E-commerce • Hybrid • Open mission',
                      borderClassName: 'border-pink-500',
                      gradientClassName: 'from-pink-500 to-purple-500'
                    }, {
                      title: 'Data Scientist',
                      details: 'FinTech • Remote • Open mission',
                      borderClassName: 'border-purple-500',
                      gradientClassName: 'from-purple-500 to-orange-500'
                    }].map(mission => <div key={mission.title} className={`bg-white rounded-xl p-5 shadow-md border-l-4 ${mission.borderClassName}`}>
                                                    <div className="flex items-start gap-4">
                                                        <div className={`w-12 h-12 bg-gradient-to-br ${mission.gradientClassName} rounded-lg flex items-center justify-center flex-shrink-0`}>
                                                            <Briefcase className="w-6 h-6 text-white" />
                                                        </div>
                                                        <div>
                                                            <h4 className="font-bold text-slate-900 mb-1">{mission.title}</h4>
                                                            <p className="text-sm text-slate-600 mb-2">{mission.details}</p>
                                                            <span className="inline-block bg-green-100 text-green-700 text-xs font-semibold px-2 py-1 rounded">
                                                                Available Now
                                                            </span>
                                                        </div>
                                                    </div>
                                                </div>)}
                                        </div>
                                    </div>
                                </div>
                            </Motion>
                        </div>
                    </div>
                </section>

                <section id="stats" className="py-20 px-6 lg:px-8 bg-gradient-to-br from-white to-orange-50">
                    <div className="max-w-6xl mx-auto">
                        <Motion tag="div" initial="hidden" whileInView="visible" viewport={{
            once: true
          }} variants={fadeIn} className="text-center mb-16">
                            <h2 className="text-4xl lg:text-5xl font-bold bg-gradient-to-r from-orange-600 to-pink-600 bg-clip-text text-transparent mb-4">
                                Global Platform, Local Opportunities
                            </h2>
                            <p className="text-slate-600 text-lg">Join the fastest-growing recruitment network</p>
                        </Motion>

                        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
                            {[{
              icon: Users,
              value: recruitersCount,
              label: 'Active Recruiters'
            }, {
              icon: Globe,
              value: countriesCount,
              label: 'Countries'
            }, {
              icon: Clock,
              value: daysCount,
              label: 'Avg. Time to Close'
            }, {
              icon: Award,
              value: 'Vetted',
              label: 'Mission Quality'
            }].map((stat, index) => <Motion tag="div" key={index} initial="hidden" whileInView="visible" viewport={{
              once: true
            }} variants={fadeIn} transition={{
              delay: index * 0.1
            }} className="bg-white rounded-2xl p-8 border-2 border-orange-100 hover:border-orange-300 hover:shadow-xl transition-all text-center">
                                    <div className="w-16 h-16 bg-gradient-to-br from-orange-100 to-pink-100 rounded-xl flex items-center justify-center mx-auto mb-4">
                                        <stat.icon className="w-8 h-8 text-orange-600" />
                                    </div>
                                    <div className="text-4xl font-bold bg-gradient-to-r from-orange-600 to-pink-600 bg-clip-text text-transparent mb-2">
                                        {stat.value}
                                    </div>
                                    <div className="text-slate-600 font-medium">{stat.label}</div>
                                </Motion>)}
                        </div>
                    </div>
                </section>

                <section id="how-it-works" className="py-20 px-6 lg:px-8 bg-gradient-to-br from-pink-50 via-purple-50 to-orange-50">
                    <div className="max-w-6xl mx-auto">
                        <Motion tag="div" initial="hidden" whileInView="visible" viewport={{
            once: true
          }} variants={fadeIn} className="text-center mb-16">
                            <h2 className="text-4xl lg:text-5xl font-bold bg-gradient-to-r from-pink-600 to-purple-600 bg-clip-text text-transparent mb-4">
                                How It Works
                            </h2>
                            <p className="text-slate-600 text-lg">Three simple steps to start earning</p>
                        </Motion>

                        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
                            {[{
              icon: Search,
              step: '01',
              title: 'Browse Missions',
              description: 'Access hundreds of open recruitment missions from companies worldwide. Filter by industry, location, and expertise fit.'
            }, {
              icon: Rocket,
              step: '02',
              title: 'Select and Work',
              description: 'Choose missions that match your expertise. Upload candidates, manage your pipeline, and communicate with clients.'
            }, {
              icon: Award,
              step: '03',
              title: 'Close Successfully',
              description: 'Move successful placements through a clear, transparent closeout process.'
            }].map((item, index) => <Motion tag="div" key={item.step} initial="hidden" whileInView="visible" viewport={{
              once: true
            }} variants={fadeIn} transition={{
              delay: index * 0.1
            }} className="bg-white rounded-2xl p-8 border-2 border-pink-100 hover:border-pink-300 hover:shadow-xl transition-all">
                                    <div className="w-16 h-16 bg-gradient-to-br from-pink-500 to-purple-500 rounded-xl flex items-center justify-center mb-6 shadow-lg">
                                        <item.icon className="w-8 h-8 text-white" />
                                    </div>
                                    <div className="text-pink-600 font-bold text-sm mb-2">{item.step}</div>
                                    <h3 className="text-2xl font-bold text-slate-900 mb-3">{item.title}</h3>
                                    <p className="text-slate-700 leading-relaxed">{item.description}</p>
                                </Motion>)}
                        </div>
                    </div>
                </section>

                <section id="benefits" className="py-20 px-6 lg:px-8 bg-gradient-to-br from-white to-pink-50">
                    <div className="max-w-6xl mx-auto">
                        <Motion tag="div" initial="hidden" whileInView="visible" viewport={{
            once: true
          }} variants={fadeIn} className="text-center mb-16">
                            <h2 className="text-4xl lg:text-5xl font-bold bg-gradient-to-r from-orange-600 via-pink-600 to-purple-600 bg-clip-text text-transparent mb-4">
                                Why Join CrossPath Platform?
                            </h2>
                            <p className="text-slate-600 text-lg">Everything you need to succeed as an independent recruiter</p>
                        </Motion>

                        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                            {[{
              icon: Globe,
              title: 'Global Reach',
              description: 'Access missions from 50+ countries and expand your network internationally.'
            }, {
              icon: Shield,
              title: 'Transparent Closeout',
              description: 'Clear placement confirmation, tracked status, and protected closeout workflow.'
            }, {
              icon: TrendingUp,
              title: 'Strong Upside',
              description: 'Work on qualified missions with opportunities to grow your recruitment business.'
            }, {
              icon: Clock,
              title: 'Fast Closures',
              description: '12 days average time to close. Work efficiently, earn quickly.'
            }, {
              icon: FileText,
              title: 'No Exclusivity',
              description: 'Work on multiple missions simultaneously. Freedom to choose.'
            }, {
              icon: Award,
              title: 'Quality Missions',
              description: 'All missions are vetted. Work with serious companies only.'
            }].map((benefit, index) => <Motion tag="div" key={benefit.title} initial="hidden" whileInView="visible" viewport={{
              once: true
            }} variants={fadeIn} transition={{
              delay: index * 0.05
            }} className="bg-white rounded-2xl p-6 border-2 border-orange-100 hover:border-orange-300 hover:shadow-xl hover:scale-105 transition-all">
                                    <div className="w-12 h-12 bg-gradient-to-br from-orange-100 to-pink-100 rounded-lg flex items-center justify-center mb-4">
                                        <benefit.icon className="w-6 h-6 text-orange-600" />
                                    </div>
                                    <h3 className="text-lg font-bold text-slate-900 mb-2">{benefit.title}</h3>
                                    <p className="text-slate-700 text-sm leading-relaxed">{benefit.description}</p>
                                </Motion>)}
                        </div>
                    </div>
                </section>

                <section className="py-20 px-6 lg:px-8 bg-gradient-to-br from-orange-50 via-pink-50 to-purple-50">
                    <div className="max-w-6xl mx-auto">
                        <Motion tag="div" initial="hidden" whileInView="visible" viewport={{
            once: true
          }} variants={fadeIn} className="text-center mb-16">
                            <h2 className="text-4xl lg:text-5xl font-bold bg-gradient-to-r from-orange-600 to-pink-600 bg-clip-text text-transparent mb-4">
                                Success Stories
                            </h2>
                            <p className="text-slate-600 text-lg">Real recruiters, real results</p>
                        </Motion>

                        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
                            {[{
              name: 'Maria Rodriguez',
              location: 'Barcelona, Spain',
              quote: 'Built a consistent placement pipeline in my first 6 months. The platform is incredibly easy to use.',
              stat: '6 months active'
            }, {
              name: 'James Thompson',
              location: 'London, UK',
              quote: 'Being able to choose my missions gives me the flexibility I always wanted.',
              stat: '23 placements'
            }, {
              name: 'Yuki Tanaka',
              location: 'Tokyo, Japan',
              quote: 'International reach is amazing. I work with companies from all over the world.',
              stat: '15 countries'
            }].map((testimonial, index) => <Motion tag="div" key={testimonial.name} initial="hidden" whileInView="visible" viewport={{
              once: true
            }} variants={fadeIn} transition={{
              delay: index * 0.1
            }} className="bg-white rounded-2xl p-8 border-2 border-orange-100 hover:border-orange-300 hover:shadow-xl transition-all relative">
                                    <div className="absolute -top-3 -right-3 bg-gradient-to-r from-orange-500 to-pink-500 text-white text-xs font-bold px-3 py-1 rounded-full shadow-lg">
                                        {testimonial.stat}
                                    </div>
                                    <div className="flex items-center gap-4 mb-4">
                                        <div className="w-12 h-12 bg-gradient-to-br from-orange-500 to-pink-500 rounded-full flex items-center justify-center text-white font-bold text-lg shadow-lg">
                                            {testimonial.name.charAt(0)}
                                        </div>
                                        <div>
                                            <div className="font-bold text-slate-900">{testimonial.name}</div>
                                            <div className="text-sm text-slate-600">{testimonial.location}</div>
                                        </div>
                                    </div>
                                    <p className="text-slate-700 leading-relaxed italic">"{testimonial.quote}"</p>
                                </Motion>)}
                        </div>
                    </div>
                </section>

                <ClientLogosCarousel />

                <section className="py-24 px-6 lg:px-8 bg-gradient-to-r from-orange-600 via-pink-600 to-purple-600">
                    <div className="max-w-4xl mx-auto text-center">
                        <Motion tag="div" initial="hidden" whileInView="visible" viewport={{
            once: true
          }} variants={fadeIn}>
                            <h2 className="text-4xl lg:text-5xl font-bold text-white mb-4">
                                Ready to Start Your Journey?
                            </h2>
                            <p className="text-xl text-white/90 mb-8">Join 10,000+ recruiters working on CrossPath Platform</p>
                            <div className="flex flex-col sm:flex-row gap-4 items-center justify-center">
                                <a href={MARKETING_URLS.platformSignup} className="bg-white text-orange-600 hover:bg-orange-50 px-10 py-4 rounded-xl font-semibold text-lg transition-all shadow-2xl hover:shadow-2xl hover:scale-105 transform flex items-center gap-2">
                                    Join as Recruiter
                                    <ArrowRight size={20} />
                                </a>
                                <div className="text-white/80 text-sm">
                                    <div>Free to join</div>
                                    <div>Start building today</div>
                                </div>
                            </div>
                        </Motion>
                    </div>
                </section>

                <PublicFooter tagline="The global recruitment marketplace connecting top talent with opportunities worldwide." />
            </div>
        </Page>;
});
};
